// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_JUST_SEND_MESSAGE = "Po\u0161li spr\u00e1vu";
export const BZ2_SEND_MESSAGE_ANONYMOUS = "Po\u0161li spr\u00e1vu predajcovi";
